// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.OrderAttributesInfo-module-orderAttributes-6ELyL .OrderAttributesInfo-module-orderAttributesText-1lVpb{color:#000}", ""]);
// Exports
exports.locals = {
	"orderAttributes": "OrderAttributesInfo-module-orderAttributes-6ELyL",
	"orderAttributesText": "OrderAttributesInfo-module-orderAttributesText-1lVpb"
};
module.exports = exports;
